import { render, staticRenderFns } from "./MoveEducation.vue?vue&type=template&id=7fc97fc4&scoped=true&"
import script from "./MoveEducation.vue?vue&type=script&lang=js&"
export * from "./MoveEducation.vue?vue&type=script&lang=js&"
import style0 from "./MoveEducation.vue?vue&type=style&index=0&id=7fc97fc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc97fc4",
  null
  
)

export default component.exports